import { useState, useEffect, useRef , useCallback } from "react";
import React from "react";
import Loader from "./Loader";
import Alert from "./Alert";
import { Link, useLocation, useParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import defaultBlogImage from "../defaultBlog.jpg";
import SearchBlogs from "./SearchBlogs";
import desktopicon from '../appimages/desktopicon.png'
import ScrollTag from "./ScrollTag";
import AppPagesHeading from "./AppPagesHeading";
import { Helmet } from 'react-helmet';
import "./Blog.css"
import { trackEvent } from "./UtilsFunction";
// react
let topic = "tensorflow"
let originalTopic = "angular"
let title = `Explore ${topic.split('')[0].toUpperCase() + topic.split('').slice(1, topic.length).join("")}: | BrowseNext`;
const description = `TensorFlow is a leading open-source machine learning framework developed by Google, designed for building, training, and deploying deep learning and AI models. It supports flexible architectures for computer vision, NLP, time series, and more — across web, mobile, and cloud platforms.`;
const keywords = 'TensorFlow, machine learning, deep learning, neural networks, AI framework, TensorFlow models, TensorFlow examples, open-source ML, computer vision, natural language processing, TensorFlow Lite, TensorFlow.js, deep learning frameworks, Google AI, ML deployment';

const Blogs = (props) => {
  const [loader, setloader] = useState(true);
  const [blogs, setBlogs] = useState([]);
  const [searchText, setSearchText] = useState("")
  const [blogView, setBlogView] = useState(true);
  const location = useLocation();
  // const[destktopSearch, setDesktopSearch] = useState(undefined)
  const [searchPageString, setSearchPageString] = useState(undefined);
  const [heading, setHeading] = useState(null)
  const blogRowRef = useRef(null);
  const blogColRef  = useRef([])
  const [pageState, setPageState] = useState(1)
  
 
  const getBlogs = (forSearch = false, forSearchQuery = "", page = pageState) => {
    // console.log("getblogs run", pageState)
    let getBlogUrl
    // console.log("blog page function", topic)
    setloader(true);
    if(forSearch){
      setHeading(forSearchQuery)
      topic = forSearchQuery;
      // console.log("checking search text", topic)
      getBlogUrl = `https://dev.to/api/articles?tag=${forSearchQuery}`
      
      let tags = document.querySelectorAll(".app_blog_tag_text")
      Array.from(tags).forEach((tag)=>{
        if(tag === forSearchQuery){
          tag.classList.add("highlight_tag")
        }
      })
      let blogHomeIcon = document.querySelectorAll('.blog_home')
       Array.from(blogHomeIcon).forEach((icon)=>{
        icon.style.backgroundColor = "#ffffff"
       })
    }else{
      setHeading(topic)
       getBlogUrl = `https://dev.to/api/articles?tag=${topic}`;
       let blogHomeIcon = document.querySelectorAll('.blog_home')
       Array.from(blogHomeIcon).forEach((icon)=>{
        icon.style.backgroundColor = "rgba(43, 52, 69, 0.1)"
       })
    }
    let finalUrl = getBlogUrl + `&page=${page}`
    // console.log("checking getBlogUrl", getBlogUrl, finalUrl)
  
    // // console.log("manageing blogs", getBlogUrl, forSearchQuery)
    axios.get(finalUrl).then((blog) => {
      setloader(false);    
      if(props.componentFrom === "home"){
        let data = blog.data
        // // console.log("routes run in home c")
         const uniqueData = [...new Map(data.map((item, index) => [item.title?.trim().toLowerCase() || `no-title-${index}`, item])).values()];
    const withImage = uniqueData.filter(b => b.cover_image && b.cover_image.length > 0);
const withoutImage = uniqueData.filter(b => !b.cover_image || b.cover_image.length === 0);
console.log("withImage Title", [...withImage])
let homeBlog = [...shuffle(withImage), ...shuffle(withoutImage)]
setBlogs(homeBlog.splice(0, 4));

        // setBlogs(blog.data.splice(0, 6));
        
        }else{  
          let data = blog.data
          console.log("1212", data)
          const uniqueData = [...new Map(data.map((item, index) => [item.title?.trim().toLowerCase() || `no-title-${index}`, item])).values()];
    const withImage = uniqueData.filter(b => b.cover_image && b.cover_image.length > 0);
const withoutImage = uniqueData.filter(b => !b.cover_image || b.cover_image.length === 0);
console.log("withImage Title", [...withImage])

setBlogs([...shuffle(withImage), ...shuffle(withoutImage)]);
      // setBlogs(blog.data);
      
      console.log("blogs object", data)
      // setBlogs(prev => [...prev, ...blog.data]);
        }
    }).catch((error)=>{
      console.log("error in netwrok api", error)
    })
  };

  const shuffle = (arr) => {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};

  function highlightTopicAfterRefresh(){
    // console.log("hightMobile text")
    let mobileTopics = document.querySelector('.mobile_suggest_topics').children
    
      Array.from(mobileTopics).forEach((topic)=>{
        if(topic){
          topic.classList.remove('active_search_pointer');
        }
      })
   }
  

  function displayDynamicBlogs() {
    setPageState(1)
    let tagNames = document.querySelectorAll('.app_blog_tag_text');
  
    tagNames.forEach((tag) => {
      tag.replaceWith(tag.cloneNode(true)); // Clone the tag to remove all listeners
    });
  
    tagNames = document.querySelectorAll('.app_blog_tag_text'); // Re-query after replacing elements
  
    tagNames.forEach((tag) => {
      tag.addEventListener("click", (e) => {
        
        tagNames.forEach((tag) => tag.classList.remove('highlight_tag'));     
     
    
        e.target.classList.add("highlight_tag");          
        getBlogs(true, tag.innerText);
      
      const newUrl = `/blogs/suggest?query=${encodeURIComponent(tag.innerText)}`;
        
       
        // Call the getBlogs function
        window.history.pushState({ path: newUrl }, '', newUrl);
    
      });
    });
  }



  useEffect(() => {
    
        if(topic === ""){
          document.title = `Explore Blogs: | BrowseNext`
        }else{
          console.log("explore", topic)
          document.title = `Explore ${topic?.split('')[0].toUpperCase() + topic?.split('').slice(1, topic.length).join("")}: | BrowseNext`
        }
    
 

    // document.title = "Market-Shops Tech Blogs"
    const urlParams = new URLSearchParams(window.location.search);
    const searchText = urlParams.get('query');
    
    // // console.log("initalload data", urlParams,searchText)
if(urlParams.size > 0){

getBlogs(true, searchText)

}else{
  topic="tensorflow"

  getBlogs();
}
// console.log("on every time")
    // displayDynamicBlogs()
  }, []);

  useEffect(() => {
    if(props.componentFrom !== "home"){
    if(topic === ""){
      document.title = `Explore Blogs: | BrowseNext`

    }else{
      document.title = `Explore ${topic.split('')[0].toUpperCase() + topic.split('').slice(1, topic.length).join("")}: | BrowseNext`
    }
  }
  }, [topic]);

  // this usefffect for every page render operations 
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const searchText = urlParams.get('query');
    // // console.log("checking search", searchText)
    if(searchText){
      setSearchText(searchText)
    }

  });

  useEffect(()=>{
    const urlParams = new URLSearchParams(window.location.search);
    const searchText = urlParams.get('query');
    const tags = document.querySelectorAll('.app_blog_tag_text')
    
    if(location.pathname === "/blogs/suggest"){
      getBlogs(true, searchText)
      tags.forEach((tag)=>{
        if(tag.innerText === searchText){
          tag.classList.add('highlight_tag')
        }
      })
      
    }

    Array.from(tags).forEach((scrollTag)=>{
          scrollTag.onClick = displayDynamicBlogs()
    })
   
  }, [])

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
   // // console.log("first..")
   
    // // // console.log("Populate blogs", location.pathname, userSearchQuery, searchParams, location.search)   
    if(location.pathname === "/blogs/search"){
      const userSearchQuery = searchParams.get("query");
      
      getBlogs(true, userSearchQuery)

    }
    // else if(location.pathname === "/blogs/suggest"){
    //   const userSearchQuery = searchParams.get("query");
    //   getBlogs(true, userSearchQuery)
    // }


  }, [location.search]); // Run this effect whenever the search part of the URL changes


  function setUrl(url){
    const newUrl = url;
    window.history.pushState({ path: newUrl }, '', newUrl);
  }
  function showBlog() {    
    setUrl("/blogs")

    const tags = document.querySelectorAll('.app_blog_tag_text')
    tags.forEach((tag)=>{
      if(tag.classList.contains("highlight_tag")){
        tag.classList.remove("highlight_tag")
      }
    })
    setSearchPageString("noSearch")
    // setHeading(originalTopic)
    topic = "tensorflow"
    getBlogs()
    if(document.getElementById('searchTagText')){
      // console.log("input placeholder changed")
      // setSearchFillText("Search blogs by tagnames...")
    document.getElementById('searchTagText').value = "" 
    highlightTopicAfterRefresh()

    }
    
  }
  
  function toggleBlog() {
    
    if (blogView === true) {
      // blogs.reverse()
      // setBlogView(false)
      setloader(true);

      setTimeout(() => {
        blogs.reverse();

        setBlogView(false);
        setloader(false);
      }, 2000);
      document.getElementById("blogFilterBtn").style.backgroundColor = "black";
      document.getElementById("blogFilterBtn").style.color = "white";
    } else {
      setloader(true);

      setTimeout(() => {
        blogs.reverse();

        setBlogView(true);
        setloader(false);
      }, 2000);

      document.getElementById("blogFilterBtn").style.backgroundColor = "#eee";
      document.getElementById("blogFilterBtn").style.color = "black";
    }
  }
  
  const convertTextIntoUrl = (text) => {
    return text
        .toString()
        .toLowerCase()
        .replace(/\s+/g, '-')           // Replace spaces with -
        .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
        .replace(/\-\-+/g, '-')         // Replace multiple - with single -
        .replace(/^-+/, '')             // Trim - from start of text
        .replace(/-+$/, '');            // Trim - from end of text
}

let tagList = [
  "JavaScript",
  "React",
  "React Native",
  "Programming Languages",
  "Figma",
  "Java",
  "Ruby",
  "C#",
  "Go",
  "Rust",
  "TypeScript",

  "Web Development",
  "Frontend",
  "Backend",
  "Fullstack",
  "HTML",
  "CSS",
  "Angular",
  "Vue.js",
  "Node.js",

  "Mobile Development",
  "iOS",
  "Android",
  "Flutter",
  "Swift",
  "Kotlin",
  "Job Hunting",
  "Interviewing",
  "Career Development",
  "Resume Writing",
  "Freelancing",
  "Remote Work",
  "Tech Industry",
  "Open Source",
  "Contributing",
  "Projects",
  "GitHub",
  "Licensing",
  "Hacktoberfest",
  "Community",
  "Security",
  "Cybersecurity",
  "Encryption",
  "Penetration Testing",
  "OWASP",
  "Authentication",
  "SSL/TLS",
  "Vulnerability Management",

  "Tools & Software",
  "VS Code",
  "Git",
  "Command Line",
  "Cloud & DevOps",
  "AWS",
  "Azure",
  "Google Cloud",
  "Docker",
  "Kubernetes",
  "CI/CD",
  "Serverless",
  "Terraform",

  "Data Science & AI",
  "Machine Learning",
  "Data Analysis",
  "Artificial Intelligence",
  "Deep Learning",
  "TensorFlow",
  "Pandas",
  "R",

  "Databases",
  "SQL",
  "NoSQL",
  "MongoDB",
  "PostgreSQL",
  "MySQL",
  "Redis",
  "Elasticsearch",
  "Firebase",
];



  // if (loader === true) {
  //   return (
  //     <>
  //       <Loader></Loader>
  //     </>
  //   );
  // } else {
  return (
    
    <>
    {
      (props.componentFrom !== "home") && 
     <Helmet>
          <title>{title}</title>
          <meta name="description" content={description} />
          <meta name="keywords" content={keywords} />

  <meta property="og:title" content={title} />
  <meta property="og:description" content={description} />
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://www.browsenext.today/blogs" />
  <meta property="og:image" content="https://www.browsenext.today/favicons.png" />
  <link rel="canonical" href="https://www.browsenext.today/blogs" />
    </Helmet>
  }
   
    <div className={props.componentFrom === "home"? `container text-left mt-4 app_container p-0`:`container text-left app_container`}>
      {/* <Alert position="bottom-center"> </Alert> */}
      {props.componentFrom != "home" &&
      <>
       <SearchBlogs setBlogs={setBlogs} setHeading={setHeading} setloader={setloader} BackBlogHomes={searchPageString}  searchText={searchText} showBlog={showBlog} />
      <ScrollTag whereFrom="blogs" tagList={tagList} showBlog={showBlog} />
      
<div
    
    className="app_product_headline blog_heading_top_div"
  >
    {/* <div
      style={{
        fontSize: "25px",
        fontWeight: "700"
       
      }}
    >
      Flash Blogs
    </div> */}

    <AppPagesHeading heading={(heading) && "Explore "+heading.split('')[0].toUpperCase() + heading.split('').slice(1, heading.length).join("")} componentFrom="blog"   />
    <i
      className={`fa-solid fa-arrow-up-short-wide product_view_icon_mmda grid_view`}
      id="blogFilterBtn"
      onClick={toggleBlog}
    ></i>
  </div>
      </>
      }




      <div className="row app_blog_main_container px-2" id="app-blog-Container" ref={blogRowRef}>
        {/* Blog Columns Start Here */}

        {loader === true ? (
          <Loader setPropClass="margin_top_setzero" />
        ) : (
          blogs.length <= 0 ? 
          (
            <>
            <div className="col-md-4 col-sm-12 col-lg-3 app_blogs no_blog_search">
                {/* <Link to={"/blog-detail/"+ blog.id  + "/"  + convertTextIntoUrl(blog.title)}> */}
                <span className="gallerytitle productname productdiscripation text-center">
                    Search for the <strong style={{color: "black"}}>"{searchText}"</strong> 
                    </span> 
                <div className="no_blog_image_found_insearch">
                  
                    <i
                        className="fa-solid fa-magnifying-glass-plus f-70"
                     
                      ></i>
                    {/* <span id="productprice" className="productprice">
                      {blog.readable_publish_date}, {blog.published_at.split("-")[0]}
                    </span> */}
                
                  </div>
                  <span className="gallerytitle productname productdiscripation text-center">
                    Blog not available yet stay tuned please try after some time...
                    </span> 
                 
              
                <button className="btn btn-primary mr-1 brand_button search_not_found_button"  onClick={showBlog}>
                       View All Blog                   
                    </button>
                
                </div>
              </> 
          ) :
          blogs.map((blog, i) => {
           
            return (
              <>
                <div className="col-md-4 col-sm-12 col-lg-3 blog_content_border app_blogs" key={blog.id + i} ref={(el)=> (blogColRef.current[i] = el)}>
                <Link to={"/blog-detail/"+ blog.id  + "/"  + convertTextIntoUrl(blog.title)} state={{ blogData: blog }} 
                  onClick={() => {
                    trackEvent("blog_click", {
                      from: window.location.pathname,
                      imagePosition: i,
                      topicAndPage: blog.title,
                      clickedImageFromComponent: props.componentFrom || "blogs"
                    });
                  }}
                >
                <div className="app_blog_cover_container ">
                <div className="galleryimg position-relative">
                    <img
                      src={
                        blog.cover_image && blog.cover_image.length > 0
                          ? blog.cover_image
                          : defaultBlogImage
                      }
                        onError={(e) =>{
                        e.target.src = defaultBlogImage;
                        e.target.alt = "Default image";
                      
                        }}
                      
                      id="productimg"
                      alt=""
                    />
                    <span id="productprice" className="productprice w-100">
                     <date> {blog.readable_publish_date}, {blog.published_at.split("-")[0]} </date>

                      {/* <i class="fa-solid fa-play  product_like"></i> */}
                    </span>
                  </div>
                  <div className="mediacontent d-inline-block app_blog_text_content_cover">
                    <p className="mb-1 totalgal reading_time"><i className="fa-solid fa-play" /> Reading Time :- {blog.reading_time_minutes
}min</p>
                    <h4 className="gallerytitle productname" id="productname" style={{color: "black", fontWeight: 700, lineHeight: "20px"}} title={blog.title}>
                      {/* {(blog.title.length > 29) ? blog.title.slice(0, 29)+ '...' : blog.title} */}
                      {props.componentFrom !== "home"?    (blog.title.length > 60) ? blog.title.slice(0, 60)+ '...' : blog.title : blog.title.slice(0, 60)}
                      
                    </h4>
                    <div className="gallerytitle productname productdiscripation">
                      {blog.description.slice(0, 100)}...
                    </div>
                    <div className="app_blog_tag_container mt-1">
                    {blog.tag_list.map((tag) => (
                    <span className="blog_tags" key={blog.id}>#{tag}</span>
                     ))}
                  
                    </div>
                  </div>
                </div>
                </Link>
                
                </div>
              </>
            );
    
          })
        )}
        {/* Blog Columns End Here */}
      </div>
    </div>
    </>
    
  );
  // }
};

export default Blogs;
